import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';
import { awsRegionSchema } from './lib/regions';

export type AwsConnectorConfig = typeof AwsConnector._.Config;

export const AwsConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Aws,
  logoPath: 'images/aws-logo.svg',
  categories: [IntegrationConnectorCategory.Cloud],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.AssumeRole,
      configSchema: z.object({
        region: awsRegionSchema,
        roleArn: z.string().trim().min(1),
      }),
      encryptedConfigSchema: z.object({
        externalId: z.string().trim().optional(),
      }),
    }),
  ]),
});
